import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Progress } from '../ui/progress';
import { TrendingUp, TrendingDown, Activity } from 'lucide-react';

const colorFor = (status) => {
  if (status === 'bullish') return 'text-green-600 bg-green-50';
  if (status === 'bearish') return 'text-red-600 bg-red-50';
  return 'text-yellow-600 bg-yellow-50';
};

const iconFor = (status) => {
  if (status === 'bullish') return <TrendingUp size={16} />;
  if (status === 'bearish') return <TrendingDown size={16} />;
  return <Activity size={16} />;
};

const SignalList = ({ signals, prefix }) => {
  if (!signals || signals.length === 0) {
    return <p className="text-center text-gray-500">No signal data available</p>;
  }
  return signals.map((signal, index) => (
    <div key={signal.name || `${prefix}-${index}`} className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className={`p-1 rounded ${colorFor(signal.status)}`}>
            {iconFor(signal.status)}
          </div>
          <span className="font-medium text-gray-900">{signal.name}</span>
        </div>
        <span className="font-bold text-purple-600">{signal.value}/100</span>
      </div>
      <Progress value={signal.value} className="h-2" />
      <p className="text-sm text-gray-600">{signal.description}</p>
    </div>
  ));
};

const SignalsCard = ({ signals, loading }) => (
  <Card data-testid="signals-card">
    <CardHeader>
      <CardTitle>AI Signal Analysis</CardTitle>
    </CardHeader>
    <CardContent>
      <Tabs defaultValue="short-term">
        <TabsList className="grid grid-cols-2 w-full">
          <TabsTrigger value="short-term">Short-Term Signals</TabsTrigger>
          <TabsTrigger value="long-term">Long-Term Signals</TabsTrigger>
        </TabsList>
        <TabsContent value="short-term" className="space-y-4 mt-6">
          {loading ? (
            <p className="text-center text-gray-500">Loading signals...</p>
          ) : (
            <SignalList signals={signals?.shortTerm} prefix="short" />
          )}
        </TabsContent>
        <TabsContent value="long-term" className="space-y-4 mt-6">
          {loading ? (
            <p className="text-center text-gray-500">Loading signals...</p>
          ) : (
            <SignalList signals={signals?.longTerm} prefix="long" />
          )}
        </TabsContent>
      </Tabs>
    </CardContent>
  </Card>
);

export default SignalsCard;
